/**
 * Sync coordination (connection-truth) — the one-shot reconnect-adoption mark.
 *
 * A MESSAGE_SYNC that arrives while BOTH sides say `processing` is normally
 * dropped: during healthy streaming the live delta stream owns the UI and a
 * snapshot would clobber newer content with older. After a RECONNECT the
 * opposite is true — the local overlay is missing every delta from the blind
 * window and the server's materialized partial is the truth. The reconnect
 * path marks the task here; the sync handler consumes the mark to adopt
 * exactly once. One-shot so a later, unrelated mid-turn sync can never
 * clobber a healthy stream.
 */
const pendingAdopt = new Set<string>();

export function markReconnectAdopt(taskId: string): void {
  pendingAdopt.add(taskId);
}

export function consumeReconnectAdopt(taskId: string): boolean {
  return pendingAdopt.delete(taskId);
}

export function _resetSyncCoordinationForTests(): void {
  pendingAdopt.clear();
}
